import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { User } from '../../../model/user';

@Component({
    selector: 'sysadmin-dialog',
    templateUrl: 'sysadmin-dialog.html',
    styleUrls: ['sysadmin-dialog.scss']
})
export class SysadminDialog implements OnInit {
    @Input() showMe: boolean = false;
    @Input() addedCommentsCount:number = 0;
  
    @Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();

    loggedUser: User = new User();
    visiblePage: string = 'sysadmin-set-infomsg';

    constructor(
        private userService: UserService
    ) {}
        
    ngOnInit() {
        this.initServices();
    }

    initServices() {
        this.loggedUser = this.userService.getUser();
    }

    closeDialog() {
        this.showMe = false;
        this.onCloseDlg.emit(true);
    }

    isSysAdmin(): boolean {
        return this.loggedUser.accessFeatures.includes('sysadmin');
    }

    showThis(value:string) {
        if (value === undefined) 
            return;
        this.visiblePage = value;
    }
}